import React from 'react';

const DescriptionTable = ({ roundId, publicRoundId, seasonId, leagueName }) => (
  <div className="table-responsive m-t-30">
    <table className="match">
      <thead className="thead--green">
        <tr>
          <th className="match__th">Round ID</th>
          <th>Public Round ID</th>
          <th>Season ID</th>
          <th className="match__th">League</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{roundId}</td>
          <td>{publicRoundId}</td>
          <td>{seasonId}</td>
          <td>{leagueName}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default DescriptionTable;